import React from "react";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from "reactstrap";

function ProactiveMonitoringDropDownOption(props) {
  return (
    <div className={props.class}>
      <UncontrolledButtonDropdown>
        <DropdownToggle caret color="link" className="p-0">
          <div style={{ display: "inline-block" }}>Proactive</div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-right">
          {props.buttons.map((button, i) => (
            <DropdownItem key={i} onClick={button.action}>
              {button.name}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </div>
  );
}

export default ProactiveMonitoringDropDownOption;
